<template>
	<section class='knd-ranglijst'>
		<div class='knd-container'>
			<article>
				<div v-html="formattedText"></div>

				<div class='knd-ranglijst__pre'>
					{{gemeente.gemeente_naam}} staat op plaats nummer
				</div>

				<div class="knd-ranglijst__plaats">
					<span class='knd-ranglijst__plaats-rank'>
						{{gemeente.ranglijst.rank}}
					</span>
					<span class="knd-ranglijst__tussen">van de </span>
					<span class='knd-ranglijst__plaats-item knd-ranglijst__plaats-soortgelijken'>
						{{$store.state.aantal_in_categorie[gemeente.inwoners_categorie]}}
					</span>
					<span class="knd-ranglijst__tussen">gemeenten</span>
				</div>

				<div class='knd-ranglijst__post'>
					met {{label[gemeente.inwoners_categorie]}} inwoners.
				</div>

				<p>
					{{gemeente.gemeente_naam}} heeft een rapportcijfer: 
				</p>

				<div class='knd-rapportcijfer'>
					{{rapportcijfer}}
				</div>

				<p>
					{{oordeelRapportcijfer(rapportcijfer)}} 
				</p>
				<div class='knd-rang__opsomming' v-html="contextCijfer()"></div>

				<div v-html="this.$store.state.data.ranglijst.outro"></div>
			</article>
		</div>
	</section>
</template>

<script>


export default {
	name: '',
	components: {},
	data () {
		var labelCategorie = {
			"Minder_dan_25000": "minder dan 25.000",
			"Van_25000_tot_50000": "tussen de 25.000 en 50.000",
			"Van_50000_tot_100000": "tussen de 50.000 en 100.000",
			'Meer_dan_100000': 'meer dan 100.000'
		}

		return {
			formattedText: '',
			van_de: '[ONBEKEND]',
			label: labelCategorie
		};
	},
	watch:{
		naam:function(newVal,oldVal){
			this.formatHtml();
		}
	},
	computed: {
		rapportcijfer:function(){
			return this.$store.getters.selectedGemeente.ranglijst.rapportcijfer;
		},

		gemeente:function(){
			return this.$store.getters.selectedGemeente;
		}	
	},
	mounted: function() {
		this.formatHtml();
	},
	methods: {
		oordeelRapportcijfer(cijfer) {
			let arr = this.$store.state.data.ranglijst.rapportcijfer;

			let feedback = arr[0].feedback;
			for(var i = 0; i < arr.length; i++ ){
				if (cijfer >= arr[i].cijfer) {
					feedback = arr[i].feedback;
				} 
			}

			let processVariables = this.output_text(feedback);
			return processVariables;
		},

		contextCijfer() {
			let arr = this.$store.state.data.ranglijst.eigenschappen;

			let feedback = '';

			for(var i = 0; i < arr.length; i++ ) {
				if (this.gemeente.ranglijst[arr[i].eigenschap]  && 
					this.gemeente.ranglijst[arr[i].eigenschap] ===  arr[i].waarde) {
					feedback += arr[i].feedback;
				}
			}

			let processVariables = this.output_text(feedback);

			return processVariables;
		},

		formatHtml() {
			this.formattedText = this.output_text(this.$store.state.data.ranglijst.intro);
		},

		loopObject(start, prop) {
			if(start[prop] === "undefined") {
				console.log(start, prop);
				return '';
			}
			return start[prop];
		},

		output_text(text) {
			if(!text) return;
			return text.replace(/{{([^}]*)}}/g, (match, capt) => {
				let arr = capt.split('.');
				let start = this;
				for(var i = 0; i < arr.length; i++) {
					start = this.loopObject(start, arr[i])
				}

				start = start.toString().replace(".", ",");
				return start
			})		
		}
	}
}
</script>
